export default "__VITE_ASSET__0MWBYynm__"